export enum MenuSelect {
  Register,
  List,
}
